/* ===============================
   TAB SWITCHING (UNCHANGED)
================================ */
function openCity(evt, cityName) {
    var i, tabcontent, tablinks;

    tabcontent = document.getElementsByClassName("custom_tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }

    tablinks = document.getElementsByClassName("custom_tablinks");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }

    document.getElementById(cityName).style.display = "block";
    evt.currentTarget.className += " active";
}

/* default open first tab */
document.addEventListener("DOMContentLoaded", function () {
    const firstTab = document.querySelector(".custom_tabcontent");
    if (firstTab) {
        firstTab.style.display = "block";
    }
});


/* ===============================
   MEGA MENU HOVER FIX
================================ */
document.addEventListener("DOMContentLoaded", function () {
    const menu = document.querySelector(".custom__menu");
    const megaMenu = document.querySelector(".custom__menu__tab__wrapper");

    if (!menu || !megaMenu) return;

    let hideTimeout;

    function showMegaMenu() {
        clearTimeout(hideTimeout);
        megaMenu.classList.add("active");
    }

    function hideMegaMenu() {
        hideTimeout = setTimeout(() => {
            megaMenu.classList.remove("active");
        }, 400); // delay time
    }

    menu.addEventListener("mouseenter", showMegaMenu);
    menu.addEventListener("mouseleave", hideMegaMenu);

    megaMenu.addEventListener("mouseenter", showMegaMenu);
    megaMenu.addEventListener("mouseleave", hideMegaMenu);
});
